import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class JobInformationService {
  constructor(private http: HttpClientService) {}

  public index(application_id, person_id): Observable<any> {
    const options = {
      params: {
        application_id: application_id,
        person_id: person_id,
      },
    };
    return this.http
      .get("/api/job_informations", options)
      .pipe(tap((_) => console.log("JobInformationService.index: Ok.")));
  }

  public create(
    job_information: any,
    application_id: number | string | null,
    person_id: number | string,
    estimated_income_id: number | string | null = null,
    account_id: number | string | null = null
  ): Observable<any> {
    const options: Record<string, any> = {
      job_information,
      application_id: application_id ?? null,
      person_id,
      estimated_income_id: estimated_income_id ?? null,
      account_id: account_id ?? null,
      job_title: job_information?.job_title ?? null,
    };

    return this.http
      .post("/api/job_informations", options)
      .pipe(tap((_) => console.log("JobInformationService.create: Ok.")));
  }

  public update(job_information, estimated_income_id: number | string = null): Observable<any> {
    const options = {
      job_information: job_information,
      estimated_income_id: estimated_income_id,
    };
    return this.http
      .put("/api/job_informations/" + job_information.id, options)
      .pipe(tap((_) => console.log("JobInformationService.update: Ok.")));
  }

  public delete(id): Observable<any> {
    return this.http
      .delete("/api/job_informations/" + id + "/delete")
      .pipe(tap((_) => console.log("JobInformationService.delete: Ok.")));
  }

  public principal_job_information(id): Observable<any> {
    const options = {
      id: id,
    };
    return this.http
      .put(`/api/job_informations/principal_job_information`, options)
      .pipe(tap((_) => console.log("JobInformationService.principal_job_information: Ok.")));
  }
}
